"use client"
import { createContext, useContext } from "react"
import type { toast } from "sonner"
import type { ShowMessageOptions, ToastT } from "./types"

export type ToastContextType = {
  addToast: (toast: Omit<ToastT, "id">) => ToastT["id"]
  removeToast: (id?: ToastT["id"]) => void
  showErrorMessage: (
    message: React.ReactNode,
    options?: ShowMessageOptions,
  ) => void
  showSuccessMessage: (
    message: React.ReactNode,
    options?: ShowMessageOptions,
  ) => void
  toastYOffset?: number
  setToastYOffset: (offset: number) => void
  resetToastYOffset: () => void
  toastXOffset?: number
  setToastXOffset: (offset: number) => void
  resetToastXOffset: () => void
  addCustomToast: typeof toast.custom
  withinToastProvider: boolean
}

export const ToastContext = createContext<ToastContextType>({
  addToast: () => undefined,
  removeToast: () => null,
  showErrorMessage: () => null,
  showSuccessMessage: () => null,
  toastYOffset: undefined,
  setToastYOffset: () => null,
  resetToastYOffset: () => null,
  toastXOffset: undefined,
  setToastXOffset: () => null,
  resetToastXOffset: () => null,
  withinToastProvider: false,
  addCustomToast: () => 0,
})

export const useToasts = () => useContext(ToastContext)
